module.exports = __webpack_public_path__ + "static/emm-artist-profile-8b43ef770f42540a5d941e2846a6a6de.jpg";